import "./index.scss";
import { HeaderFullDataProps } from "components/HeaderNew/HeaderFull/types";
import { HeaderLiteDataProps } from "components/HeaderNew/HeaderLite/types";
import { Poly } from "components/Poly";
import LangSelect from "components/HeaderNew/components/LangSelect";
import React, { forwardRef } from "react";
import cn from "classnames";

type Props = (HeaderFullDataProps | HeaderLiteDataProps) & {
  hasLanguageSelect?: boolean;
  location?: { href: string; pathname: string };
};

const HeaderTop = forwardRef<HTMLDivElement | null, Props>(
  ({ menu, hasLanguageSelect, location }: Props, ref) => {
    const activeMenu = menu.find(({ anchorProps: { href, to } }) =>
      location?.pathname.includes(href || to || ""),
    );

    return (
      <nav ref={ref} className="header-top" aria-label="primary-navigation">
        <div className="header-top__list-wrapper">
          <ul className="header-top__list">
            {menu.map((item) => {
              return (
                <li className="header-top__item" key={item.label}>
                  <Poly
                    {...item.anchorProps}
                    className={cn("header-top__link", {
                      active: activeMenu?.label === item.label,
                    })}
                    aria-current={
                      activeMenu?.label === item.label ? "page" : false
                    }
                  >
                    {item.label}
                  </Poly>
                </li>
              );
            })}
          </ul>
          {hasLanguageSelect && (
            <div className="header-top__lang-select">
              <LangSelect />
            </div>
          )}
        </div>
      </nav>
    );
  },
);

export default HeaderTop;
